import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import fetchConsiders from './fetch-considers'
import { IStatement } from '../../../model/statement'

export default async function unconsiderStatement(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementUtils.statementService.unconsider(statement).then((result: any) => {
        fetchConsiders(context, statement)
    })

    return
}